// Avisos a la app · escribir y mandar un push a los clientes sin entrar a OneSignal.
//
// LO QUE SE MANDA DE AQUI LE LLEGA A TODOS LOS CLIENTES CON LA APP Y NO SE PUEDE RETIRAR.
// Por eso: vista previa de como se vera, confirmacion aparte antes de mandar, y el historial
// de lo ultimo enviado a la vista — el error clasico es creer que no se mando y repetirlo.
import React from 'react';
const { useState, useEffect, useCallback, useRef } = React;

const CSS = `
.aa-ta{width:100%;min-height:120px;border:1px solid var(--ink,#111827);padding:12px;font-size:16px;outline:none;background:#FFFFFF;font-family:inherit;line-height:1.5;resize:vertical;box-sizing:border-box}
.aa-nota{font-size:12px;color:#64748B;margin:6px 0 0;line-height:1.45}
.aa-ok{background:#E6F4EA;border:1px solid #1D8A4E;color:#14532D;padding:12px;font-size:13px;line-height:1.5}
.aa-hecho{text-align:center;padding:28px 16px}
.aa-pal{width:62px;height:62px;border-radius:31px;background:#1D8A4E;color:#FFFFFF;font-size:32px;line-height:62px;margin:0 auto 14px}
.aa-hecho h3{margin:0 0 6px;font-size:20px;font-weight:500}
.aa-hecho .n{font-size:34px;font-weight:500;line-height:1.1;margin:14px 0 2px}
.aa-hecho .eco{background:#F8FAFC;border:1px solid #E2E8F0;padding:12px;margin-top:18px;text-align:left}
.aa-hecho .eco b{display:block;font-size:14px}
.aa-hecho .eco small{display:block;color:#64748B;font-size:13px;margin-top:3px;white-space:pre-wrap}
.aa-gal{border:1px solid #E2E8F0;background:#F8FAFC;padding:10px;margin-top:8px}
.aa-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(88px,1fr));gap:8px;max-height:300px;overflow-y:auto;margin-top:8px}
.aa-foto-b{padding:0;border:2px solid transparent;background:none;cursor:pointer;line-height:0;border-radius:6px;overflow:hidden}
.aa-foto-b.on{border-color:#111827}
.aa-foto-b img{width:100%;height:88px;object-fit:cover;display:block;background:#E2E8F0}
.aa-mal{background:#FEF2F2;border:1px solid #B91C1C;color:#7F1D1D;padding:8px 10px;font-size:12px;margin-top:6px}
.aa-tel{background:#111827;border-radius:22px;padding:14px 12px 20px;margin-top:8px}
.aa-hora{text-align:center;color:#FFFFFF;font-size:30px;font-weight:300;letter-spacing:1px;line-height:1.1}
.aa-fecha{text-align:center;color:#C7C7CC;font-size:12px;margin-bottom:14px}
.aa-card{background:rgba(255,255,255,.14);border-radius:14px;padding:10px 12px;display:flex;gap:10px;align-items:flex-start}
.aa-card.vacia{opacity:.45}
.aa-ic{width:36px;height:36px;border-radius:9px;background:#FFFFFF;display:flex;align-items:center;justify-content:center;font-weight:500;font-size:12px;color:#111827;flex-shrink:0;position:relative}
.aa-tx{flex:1;min-width:0;color:#FFFFFF}
.aa-tx b{display:block;font-size:14px;line-height:1.3;font-weight:600}
.aa-tx small{display:block;font-size:13px;color:#E5E7EB;margin-top:1px;line-height:1.35;white-space:pre-wrap;word-break:break-word}
.aa-ah{font-size:11px;color:#9CA3AF;flex-shrink:0}
.aa-mini{width:42px;height:42px;border-radius:7px;object-fit:cover;flex-shrink:0;background:#374151}
.aa-corte{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
.aa-modo{display:flex;gap:6px;justify-content:center;margin-top:10px}
.aa-modo button{padding:5px 12px;font-size:11px;border:1px solid #4B5563;background:transparent;color:#9CA3AF;cursor:pointer;border-radius:12px}
.aa-modo button.on{background:#FFFFFF;border-color:#FFFFFF;color:#111827;font-weight:500}
.aa-foto{margin-top:8px;border-radius:10px;width:100%;max-height:150px;object-fit:cover;display:block}
.aa-pie{display:flex;gap:10px;justify-content:center;margin-top:12px;font-size:11px;color:#9CA3AF}
.aa-row{display:flex;gap:8px;margin-top:8px}
.aa-row button{flex:1;padding:9px 6px;font-size:13px;border:1px solid #CBD5E1;background:#FFFFFF;color:#475569;cursor:pointer}
.aa-row button.on{border-color:#111827;color:#0F172A;font-weight:600}
.aa-sw{display:flex;align-items:center;justify-content:space-between;gap:12px;border:1px solid #E2E8F0;background:#FFFFFF;padding:12px;margin-top:16px}
.aa-sw .t b{display:block;font-size:14px}
.aa-sw .t small{display:block;color:#64748B;font-size:12px;margin-top:2px;line-height:1.45}
.aa-tg{flex-shrink:0;width:50px;height:30px;border-radius:15px;border:1px solid #CBD5E1;background:#E2E8F0;position:relative;cursor:pointer;padding:0}
.aa-tg .b{position:absolute;top:2px;left:2px;width:24px;height:24px;border-radius:12px;background:#FFFFFF;box-shadow:0 1px 3px rgba(0,0,0,.25);transition:left .15s}
.aa-tg.on{background:#111827;border-color:#111827}
.aa-tg.on .b{left:22px}
.aa-conf{border:1px solid #B91C1C;background:#FEF2F2;padding:12px;margin-top:14px}
.aa-conf h4{margin:0 0 4px;font-size:13px;color:#7F1D1D}
.aa-h{border-top:1px solid #E2E8F0;margin-top:18px;padding-top:12px}
.aa-i{border-bottom:1px solid #F1F5F9;padding:8px 0;font-size:13px}
.aa-i b{display:block}
.aa-i small{color:#64748B;font-size:12px}
.aa-i .mal{color:#B91C1C}
`;

const api = async (ruta, opts = {}) => {
  const tok = localStorage.getItem('token');
  const r = await fetch(ruta, {
    ...opts,
    headers: { 'Content-Type': 'application/json', ...(tok ? { Authorization: 'Bearer ' + tok } : {}), ...(opts.headers || {}) },
    ...(opts.body ? { body: JSON.stringify(opts.body) } : {}),
  });
  const j = await r.json().catch(() => null);
  if (!r.ok || !j || j.ok === false) {
    const e = new Error((j && j.error) || ('no se pudo (HTTP ' + r.status + ')'));
    e.data = j || {};
    throw e;
  }
  return j;
};

const cuando = iso => {
  const t = Date.parse(iso || '');
  if (!t) return '';
  return new Date(t).toLocaleString('es-MX', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
};

export default function AvisosApp({ onCerrar }) {
  const [titulo, setTitulo] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [imagen, setImagen] = useState('');
  const [ios, setIos] = useState(true);
  const [android, setAndroid] = useState(true);
  // El globito rojo del icono. Va prendido por defecto porque es lo que hace que el cliente
  // vea que tiene algo pendiente aunque no haya abierto la notificacion.
  const [badge, setBadge] = useState(true);
  // Sin esto la notificacion llega MUDA en iPhone: no es que suene por defecto.
  const [sonido, setSonido] = useState(true);
  const [imgMala, setImgMala] = useState(false);
  const [galeria, setGaleria] = useState(null);   // null = cerrada
  const [buscaFoto, setBuscaFoto] = useState('');
  const [cargandoFotos, setCargandoFotos] = useState(false);
  const [cats, setCats] = useState([]);
  const [cat, setCat] = useState('');   // '' = lo último subido a la biblioteca
  // La imagen NO se ve completa de entrada: iPhone y Android muestran una miniatura y la foto
  // grande solo al desplegar. Se puede ver de las dos formas para no llevarse una sorpresa.
  const [abierta, setAbierta] = useState(false);
  const [soloPrueba, setSoloPrueba] = useState(false);
  const [subId, setSubId] = useState('');
  const [resultado, setResultado] = useState(null);   // acuse: que se mando y a cuantos
  // El cuerpo se desplaza: un error pintado arriba no se ve si estas abajo en el boton.
  const cuerpo = useRef(null);
  const alPrincipio = () => { try { cuerpo.current.scrollTop = 0; } catch (e) {} };
  const [confirmando, setConfirmando] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [err, setErr] = useState('');
  const [aviso, setAviso] = useState('');
  const [estado, setEstado] = useState(null);
  const [verLlave, setVerLlave] = useState(false);
  const [appId, setAppId] = useState('b70c50e9-26b8-45c5-9789-3d8b3ade00ec');
  const [apiKey, setApiKey] = useState('');

  const cargar = useCallback(() => {
    api('/api/avisos-app').then(setEstado).catch(e => setErr(e.message));
  }, []);
  useEffect(() => { cargar(); }, [cargar]);

  const listo = mensaje.trim() && (ios || android);

  const guardarPrueba = async () => {
    setErr(''); setAviso('');
    try {
      await api('/api/avisos-app/prueba', { method: 'POST', body: { sub_id: subId } });
      setSubId(''); setAviso('Teléfono de prueba guardado.');
      cargar();
    } catch (e) { setErr(e.message); }
  };

  const abrirGaleria = async (texto, categoria) => {
    setCargandoFotos(true); setErr('');
    try {
      const j = await api('/api/avisos-app/medios?buscar=' + encodeURIComponent(texto || '') +
        '&categoria=' + encodeURIComponent(categoria || ''));
      setGaleria(j.fotos || []);
    } catch (e) { setErr(e.message); setGaleria([]); }
    finally { setCargandoFotos(false); }
  };

  // Las categorias se piden una sola vez, al abrir la galeria por primera vez.
  const abrirPrimera = async () => {
    abrirGaleria('', '');
    if (!cats.length) {
      try { const j = await api('/api/avisos-app/categorias'); setCats(j.categorias || []); }
      catch (e) { /* sin categorias se puede seguir usando la biblioteca */ }
    }
  };

  const guardarLlave = async () => {
    setErr(''); setAviso('');
    try {
      await api('/api/avisos-app/llave', { method: 'POST', body: { app_id: appId, api_key: apiKey } });
      setApiKey(''); setVerLlave(false);
      setAviso('Llave guardada. Ya se pueden mandar avisos.');
      cargar();
    } catch (e) { setErr(e.message); }
  };

  const mandar = async () => {
    setErr(''); setAviso(''); setConfirmando(false); setEnviando(true);
    try {
      const j = await api('/api/avisos-app', { method: 'POST',
        body: { titulo, mensaje, imagen, ios, android, badge, sonido, solo_prueba: soloPrueba } });
      setResultado({ recibieron: j.recibieron, porPlataforma: j.por_plataforma,
        titulo: titulo.trim(), mensaje: mensaje.trim() });
      cargar();
    } catch (e) { setErr(e.message); alPrincipio(); }
    finally { setEnviando(false); }
  };

  return (
    <div className="c2-sheet" role="dialog" aria-modal="true" aria-label="Avisos a la app">
      <style>{CSS}</style>
      <div className="c2-sh-top">
        <button type="button" className="c2-ib" aria-label="Cerrar" onClick={onCerrar}>✕</button>
        <div className="c2-sh-t">Avisos a la app<small>Notificación a los clientes</small></div>
      </div>

      <div className="c2-sh-body" ref={cuerpo}>
        {resultado ? (
          <div className="aa-hecho" role="status">
            <div className="aa-pal">✓</div>
            <h3>Aviso enviado</h3>
            {resultado.recibieron != null ? (<>
              <div className="n">{resultado.recibieron}</div>
              <p className="aa-nota" style={{ margin: 0 }}>
                {resultado.recibieron === 1 ? 'teléfono lo recibió' : 'teléfonos lo recibieron'}
                {resultado.porPlataforma && (resultado.porPlataforma.ios || resultado.porPlataforma.android)
                  ? ' · ' + resultado.porPlataforma.ios + ' iPhone y ' + resultado.porPlataforma.android + ' Android'
                  : ''}
              </p>
              {resultado.recibieron === 0 && (
                <div className="aa-mal" style={{ marginTop: 14, textAlign: 'left' }}>
                  No le llegó a nadie. Puede que ningún cliente tenga la app con notificaciones
                  permitidas en la plataforma que escogiste.
                </div>
              )}
            </>) : (
              <p className="aa-nota" style={{ margin: 0 }}>OneSignal lo aceptó y va en camino.</p>
            )}
            <div className="eco">
              <b>{resultado.titulo || 'YOOHOO'}</b>
              <small>{resultado.mensaje}</small>
            </div>
          </div>
        ) : (<>
        {err && <div className="c2-err" role="alert">{err}</div>}
        {aviso && <div className="aa-ok">{aviso}</div>}

        {estado && !estado.configurado && !verLlave && (
          <div className="c2-warn">
            Falta la llave de OneSignal. Sin ella no se puede mandar nada.
            <button type="button" className="c2-btn ghost" style={{ marginTop: 10 }} onClick={() => setVerLlave(true)}>Ponerla ahora</button>
          </div>
        )}

        {estado && estado.configurado && !verLlave && (
          <p className="aa-nota" style={{ marginTop: 0 }}>
            Conectado a OneSignal (llave {estado.llave && estado.llave.cola}).{' '}
            <button type="button" className="c2-link" onClick={() => setVerLlave(true)}>Cambiar la llave</button>
          </p>
        )}

        {verLlave && (
          <div className="aa-conf" style={{ borderColor: '#D97706', background: '#FFFBEB' }}>
            <h4 style={{ color: '#78350F' }}>Llave de OneSignal</h4>
            <p className="aa-nota" style={{ margin: '0 0 8px' }}>
              La sacas de OneSignal → <b>Keys &amp; IDs</b> → <b>REST API Key</b>. Se guarda solo en el
              servidor y nunca se vuelve a mostrar completa.
            </p>
            <label className="c2-fl" htmlFor="aa-app" style={{ marginTop: 4 }}>APP ID</label>
            <input id="aa-app" className="c2-in" value={appId} onChange={e => setAppId(e.target.value)} />
            <label className="c2-fl" htmlFor="aa-key">REST API KEY</label>
            <input id="aa-key" className="c2-in" type="password" autoComplete="off" value={apiKey}
              onChange={e => setApiKey(e.target.value)} placeholder="pégala aquí" />
            <div className="c3-2b" style={{ marginTop: 10 }}>
              <button type="button" className="c2-btn ghost" onClick={() => { setVerLlave(false); setApiKey(''); }}>Cancelar</button>
              <button type="button" className="c2-btn" disabled={!apiKey.trim()} onClick={guardarLlave}>Guardar llave</button>
            </div>

            <label className="c2-fl" htmlFor="aa-sub">MI TELÉFONO PARA PRUEBAS</label>
            <p className="aa-nota" style={{ margin: '0 0 6px' }}>
              De OneSignal → Users &amp; subscriptions → Subscriptions: el <b>Subscription ID</b> del
              renglón de tu teléfono. Con esto puedes probar sin que le llegue a nadie más.
              {estado && estado.llave && estado.llave.hay_prueba
                ? ' Ya hay uno guardado (' + estado.llave.prueba + ').' : ''}
            </p>
            <input id="aa-sub" className="c2-in" value={subId} onChange={e => setSubId(e.target.value)}
              placeholder="c8469f65-fbe7-47c6-…" />
            <button type="button" className="c2-btn ghost" style={{ marginTop: 8, width: '100%' }}
              disabled={!subId.trim()} onClick={guardarPrueba}>Guardar mi teléfono</button>
          </div>
        )}

        <label className="c2-fl" htmlFor="aa-t">TÍTULO (OPCIONAL)</label>
        <input id="aa-t" className="c2-in" maxLength={60} value={titulo}
          onChange={e => setTitulo(e.target.value)} placeholder="Llegó ropa nueva" />

        <label className="c2-fl" htmlFor="aa-m">MENSAJE</label>
        <textarea id="aa-m" className="aa-ta" maxLength={180} value={mensaje}
          onChange={e => setMensaje(e.target.value)}
          placeholder="Pantalones de dama desde $330. Entra a verlos." />
        <p className="aa-nota">{mensaje.length}/180 · corto se lee completo en la pantalla bloqueada.</p>

        <label className="c2-fl" htmlFor="aa-i">IMAGEN (OPCIONAL)</label>
        <input id="aa-i" className="c2-in" value={imagen} onChange={e => { setImagen(e.target.value); setImgMala(false); }}
          placeholder="https://yoohoo.mx/…/foto.jpg" />
        <p className="aa-nota">
          Pega la liga de cualquier foto que ya esté publicada en internet: de la tienda, de la
          biblioteca de WordPress o de donde sea, mientras se pueda abrir sin contraseña. Si la
          dejas vacía el aviso va sin imagen.
        </p>
        {imgMala && <div className="aa-mal">No se pudo cargar esa imagen. Revisa que la liga abra
          directo en el navegador y que termine en .jpg, .png o .webp.</div>}

        {galeria === null ? (
          <button type="button" className="c2-btn ghost" style={{ marginTop: 8 }}
            disabled={cargandoFotos} onClick={abrirPrimera}>
            {cargandoFotos ? 'Cargando fotos…' : 'Escoger de la biblioteca'}
          </button>
        ) : (
          <div className="aa-gal">
            <div style={{ display: 'flex', gap: 8 }}>
              <input className="c2-in" type="search" value={buscaFoto} placeholder="Buscar por nombre…"
                onChange={e => setBuscaFoto(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); abrirGaleria(buscaFoto, cat); } }} />
              <button type="button" className="c2-btn ghost" style={{ flexShrink: 0 }}
                onClick={() => { setGaleria(null); setBuscaFoto(''); }}>Cerrar</button>
            </div>

            <select className="c2-in" style={{ marginTop: 8 }} value={cat}
              onChange={e => { setCat(e.target.value); abrirGaleria(buscaFoto, e.target.value); }}>
              <option value="">Lo último que se subió</option>
              {cats.map(c => (
                <option key={c.id} value={c.id}>{c.nombre} ({c.productos})</option>
              ))}
            </select>

            {cargandoFotos && <p className="aa-nota">Buscando…</p>}
            {!cargandoFotos && galeria.length === 0 && <p className="aa-nota">No hay fotos con ese nombre.</p>}

            <div className="aa-grid">
              {galeria.map(f => (
                <button type="button" key={f.id} title={f.titulo}
                  className={'aa-foto-b' + (imagen === f.url ? ' on' : '')}
                  onClick={() => { setImagen(f.url); setImgMala(false); }}>
                  <img src={f.mini} alt={f.titulo} loading="lazy" />
                </button>
              ))}
            </div>
            <p className="aa-nota">
              {cat ? 'Fotos de los productos de esa categoría.' : 'Lo último que se subió a la tienda, lo más reciente primero.'}
              {' '}Toca una y se pone arriba.
            </p>
          </div>
        )}

        <label className="c2-fl">¿A QUIÉN LE LLEGA?</label>
        <div className="aa-row">
          <button type="button" className={ios ? 'on' : ''} onClick={() => setIos(v => !v)}>iPhone {ios ? '✓' : ''}</button>
          <button type="button" className={android ? 'on' : ''} onClick={() => setAndroid(v => !v)}>Android {android ? '✓' : ''}</button>
        </div>

        <div className="aa-sw" style={soloPrueba ? { borderColor: '#D97706', background: '#FFFBEB' } : null}>
          <span className="t">
            <b>Solo a mi teléfono (prueba)</b>
            <small>{soloPrueba
              ? (estado && estado.llave && estado.llave.hay_prueba
                  ? 'Nadie más lo recibe. Sirve para revisar cómo se ve.'
                  : 'Falta guardar tu teléfono abajo, en “Cambiar la llave”.')
              : 'Apagado: le llega a todos los clientes con la app.'}</small>
          </span>
          <button type="button" className={'aa-tg' + (soloPrueba ? ' on' : '')} role="switch" aria-checked={soloPrueba}
            aria-label="Solo a mi teléfono" onClick={() => setSoloPrueba(v => !v)}><span className="b" /></button>
        </div>

        <div className="aa-sw">
          <span className="t">
            <b>Marcar el icono con el globito</b>
            <small>{badge
              ? 'Le suma 1 al número rojo del icono. Se queda ahí hasta que abra la app.'
              : 'Solo llega la notificación. El icono no se marca.'}</small>
          </span>
          <button type="button" className={'aa-tg' + (badge ? ' on' : '')} role="switch" aria-checked={badge}
            aria-label="Marcar el icono con el globito" onClick={() => setBadge(v => !v)}><span className="b" /></button>
        </div>
        <p className="aa-nota">
          Déjalo prendido para algo que quieres que atienda (su pedido, un apartado por vencer).
          Apágalo para promociones: si cada oferta deja número rojo, acaban ignorándolo.
        </p>

        <div className="aa-sw">
          <span className="t">
            <b>Que suene</b>
            <small>{sonido
              ? 'Suena como cualquier notificación del teléfono.'
              : 'Llega en silencio: solo aparece en pantalla.'}</small>
          </span>
          <button type="button" className={'aa-tg' + (sonido ? ' on' : '')} role="switch" aria-checked={sonido}
            aria-label="Que suene" onClick={() => setSonido(v => !v)}><span className="b" /></button>
        </div>
        <p className="aa-nota">
          En iPhone, sin esto la notificación llega muda. Apágalo solo si vas a mandar algo
          de madrugada o varios seguidos.
        </p>

        <label className="c2-fl">ASÍ LO VA A VER EN SU TELÉFONO</label>
        <div className="aa-tel">
          <div className="aa-hora">{new Date().toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit', hour12: false })}</div>
          <div className="aa-fecha">{new Date().toLocaleDateString('es-MX', { weekday: 'long', day: 'numeric', month: 'long' })}</div>

          <div className={'aa-card' + (mensaje.trim() ? '' : ' vacia')}>
            <span className="aa-ic">yh
              {badge && <span style={{ position:'absolute', top:-6, right:-6, minWidth:17, height:17, borderRadius:9,
                background:'#FF3B30', color:'#FFFFFF', fontSize:10, fontWeight:600, lineHeight:'17px', textAlign:'center', padding:'0 4px' }}>1</span>}
            </span>
            <span className="aa-tx">
              <b>{titulo.trim() || 'YOOHOO'}</b>
              <small className={abierta ? '' : 'aa-corte'}>{mensaje.trim() || 'Aquí va tu mensaje…'}</small>
              {abierta && imagen.trim() && !imgMala &&
                <img className="aa-foto" src={imagen} alt=""
                  onError={() => setImgMala(true)} onLoad={() => setImgMala(false)} />}
            </span>
            {!abierta && imagen.trim() && !imgMala &&
              <img className="aa-mini" src={imagen} alt=""
                onError={() => setImgMala(true)} onLoad={() => setImgMala(false)} />}
            {!abierta && <span className="aa-ah">ahora</span>}
          </div>

          <div className="aa-modo">
            <button type="button" className={!abierta ? 'on' : ''} onClick={() => setAbierta(false)}>Como le llega</button>
            <button type="button" className={abierta ? 'on' : ''} onClick={() => setAbierta(true)}>Al desplegarla</button>
          </div>

          <div className="aa-pie">
            <span>{badge ? 'con globito' : 'sin globito'}</span>
            <span>·</span>
            <span>{sonido ? 'con sonido' : 'en silencio'}</span>
            <span>·</span>
            <span>{[ios && 'iPhone', android && 'Android'].filter(Boolean).join(' y ') || 'nadie'}</span>
          </div>
        </div>
        <p className="aa-nota">
          De entrada el teléfono muestra dos renglones y la foto en miniatura. La clienta ve el
          texto completo y la imagen grande al mantener apretada la notificación. Por eso conviene
          que lo importante vaya en el título y al principio del mensaje.
        </p>


        {estado && estado.avisos && estado.avisos.length > 0 && (
          <div className="aa-h">
            <label className="c2-fl" style={{ marginTop: 0 }}>LO ÚLTIMO QUE SE MANDÓ</label>
            {estado.avisos.slice(0, 6).map((a, i) => (
              <div className="aa-i" key={i}>
                <b>{a.titulo || a.mensaje}</b>
                <small>
                  {cuando(a.at)} · {a.por || 'alguien'}{a.prueba ? ' · prueba' : ''}
                  {a.ok ? (() => {
                    const n = a.entregadas != null ? a.entregadas : a.recibieron;
                    if (n == null) return ' · enviado';
                    const p = a.por_plataforma;
                    return ' · llegó a ' + n +
                      (p && (p.ios || p.android) ? ' · ' + p.ios + ' iPhone y ' + p.android + ' Android' : '');
                  })() : <span className="mal"> · falló: {a.error}</span>}
                </small>
              </div>
            ))}
          </div>
        )}
        </>)}
      </div>

      <div className="c2-sh-foot">
        {resultado ? (
          <div className="c3-2b" style={{ width: '100%' }}>
            <button type="button" className="c2-btn ghost" onClick={onCerrar}>Cerrar</button>
            <button type="button" className="c2-btn" onClick={() => {
              setResultado(null); setTitulo(''); setMensaje(''); setImagen(''); setImgMala(false);
            }}>Escribir otro</button>
          </div>
        ) : confirmando ? (
          <div style={{ width: '100%' }}>
            <div className="aa-conf" style={soloPrueba ? { borderColor: '#1D8A4E', background: '#E6F4EA' } : null}>
              <h4>{soloPrueba ? 'Solo a tu teléfono' : 'Esto le llega a TODOS los clientes con la app'}</h4>
              <p className="aa-nota" style={{ margin: 0 }}>
                {soloPrueba
                  ? 'Es una prueba: nadie más la recibe.'
                  : 'Una notificación enviada no se puede retirar. Revisa el texto de arriba antes de confirmar.'}
              </p>
            </div>
            <div className="c3-2b" style={{ marginTop: 10 }}>
              <button type="button" className="c2-btn ghost" onClick={() => setConfirmando(false)}>Cancelar</button>
              <button type="button" className="c2-btn" onClick={mandar}>Sí, mandarlo</button>
            </div>
          </div>
        ) : (
          <div className="c3-2b" style={{ width: '100%' }}>
            <button type="button" className="c2-btn ghost" onClick={onCerrar}>Cerrar</button>
            <button type="button" className="c2-btn" disabled={!listo || enviando || (estado && !estado.configurado)}
              onClick={() => setConfirmando(true)}>
              {enviando ? 'Enviando…' : 'Mandar aviso'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
